import { JSX } from 'react'

import Container from 'app/components/base/Container'
import Divider from 'app/components/base/Divider'
import Stack from 'app/components/base/Stack'
import HelpCenterLeftMenuFeature from 'app/features/HelpCenter/HelpCenterLeftMenuFeature'

interface HelpCenterContainerProps {
  categorySlug: string
  isLoading: boolean
  children: JSX.Element
}

const HelpCenterContainer = ({
  categorySlug,
  isLoading,
  children
}: HelpCenterContainerProps) => {
  return (
    <Container maxWidth="md" sx={{ pt: 3, pb: { xs: 7, md: 19 } }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={{ xs: 3, md: 4 }}
        divider={
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: { xs: 'none', md: 'flex' } }}
          />
        }
      >
        <HelpCenterLeftMenuFeature
          categorySlug={categorySlug}
          isLoading={isLoading}
        />

        {children}
      </Stack>
    </Container>
  )
}

export default HelpCenterContainer
